import React from 'react';
import { twMerge } from 'tailwind-merge';
import StatusBadge from './StatusBadge';
import Notification from './Notification';
import { AvatarSize } from './ChatAvatar';
import { Statuses } from 'flow/types/Extension';

interface Props {
    className?: string;
    children?: React.ReactNode;
    status?: Statuses;
    count?: number;
    size?: AvatarSize;
}

const sizes = {
    small: 'size-6 text-2xs',
    medium: 'size-9',
    toolbar: 'size-10',
    large: 'size-14 text-lg',
    extraLarge: 'size-20 text-2xl',
    videoLarge: 'size-40 text-3xl',
};

const AiUserAvatar = ({
    className = '',
    children = <div />,
    status,
    count,
    size = 'extraLarge',
}: Props) => {
    const animate = ['ringingCall', 'inCall', 'inExternalCall'].includes(
        status,
    );

    const flavorRegex = /(?:bg|color)-(flavor-\d+)/;
    const match = flavorRegex.exec(className);
    const flavor = match?.[1];

    return (
        <div className="user-avatar relative inline-block text-xs">
            <div
                className={twMerge(
                    'relative flex items-center justify-center rounded-full font-bold text-white',
                    sizes[size],
                )}
            >
                <div
                    className={twMerge(
                        'flex items-center justify-center rounded-t-[40px] rounded-b-[80px]',
                        flavor ? `bg-${flavor}` : '',
                        sizes[size],
                    )}
                >
                    {children}
                </div>
            </div>
            {count ? (
                <Notification className="-me-1">{count}</Notification>
            ) : null}
            {status && status !== 'unknown' ? (
                <StatusBadge status={status} size={size} animate={animate} />
            ) : null}
        </div>
    );
};

export default AiUserAvatar;
